<template>
    <div>
        <div class="container-fluid">
            <legend>Учет заказов</legend>
            <div v-if="$route.query.time && $route.query.panelUserId">

                <print-by-time-and-panel-user
                        :time="$route.query.time"
                        :panel-user-id="$route.query.panelUserId"
                        :allow-printing="false"
                        :allow-marking="true"
                ></print-by-time-and-panel-user>
            </div>

            <div v-else>
                <table class="table table-bordered table-hover table-sm">
                    <tbody>
                    <tr v-for="(item, index) in list">
                        <td>
                            {{index + 1}}
                        </td>
                        <td>
                            <router-link :to="{ name: 'book-delivery', query: { time: item.DeliveryDate, panelUserId: item.PanelUserId }}">
                                {{item.DeliveryDate}}
                            </router-link>
                        </td>
                        <td>
                            {{item.Login}}
                        </td>
                        <td>
                            {{item.Lname}} {{item.Fname}} {{item.Mname}}
                        </td>
                        <td>
                            {{item.OrderCount}}
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
import _ from 'lodash';
import PrintByTimeAndPanelUser from '@/admin/modules/Delivery/_components/PrintByTimeAndPanelUser.vue';
import api from '@/admin/modules/Delivery/api';
import { post } from '@/admin/services/api/http-utils';

const url = `${process.env.VUE_APP_API_HOST}admin/delivery`;

export default {
  components: {
    PrintByTimeAndPanelUser,
  },
  data() {
    return {
      list: [],
    };
  },
  created() {
    this.fetchDebtByTourId();
  },
  methods: {
    async fetchDebtByTourId() {
      const { data } = await api.fetchDebtByTourId();
      this.list = data;
    },
  },
};
</script>
